import { createSelector } from 'reselect';
import { sortByPropWithOrder } from '../../../utils/utils';

export const CHANNEL_ORDER = [
  'UK Holiday Parks',
  'European Holiday Parks',
  'UK Lodge Breaks',
  'UK Cottages',
  'UK Camping & Touring Parks',
  'Boating Holidays',
];

export const channelsSelector = (state) => state.data.channels.channels;

export const channelsSortedSelector = createSelector([channelsSelector], (channelData) =>
  sortByPropWithOrder(channelData, CHANNEL_ORDER, 'name'),
);

export const channelGetKeyToCodeMapSelector = createSelector([channelsSelector], (channelData) =>
  Object.fromEntries(channelData.map((channel) => [channel.key, channel.code])),
);
